import React from 'react';
import { observer } from 'mobx-react';
import { Cropper } from 'apps/components/cropper';
import Icon from 'components/Icon';
import type { FileFieldStore } from 'libs/forms/fieldStores';

// @ts-ignore
import { getDroppedOrSelectedFiles } from 'html5-file-selector';

import { CropperWrapper, Wrapper, InputFileStyled } from './AvatarInput.styled';

interface AvatarInputProps {
  fieldStore: FileFieldStore;
  disabled: boolean;
  size: number | string;
}

export const AvatarInput = observer(function AvatarInput(
  props: AvatarInputProps,
) {
  const { fieldStore, disabled, size = '120px' } = props;

  const handleRemoveFile = () => {
    fieldStore.RemoveFile();
  };

  const handleDragEnter = () => {
    fieldStore.Dragging();
  };

  const handleDragLeave = () => {
    fieldStore.StopDragging();
  };

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    getDroppedOrSelectedFiles(event).then((list: any[]) => {
      if (list.length > 0) {
        fieldStore.Drop(
          list,
          [],
          !['avatar', 'image'].includes(fieldStore.fieldName),
        );
      }
    });
  };

  if (fieldStore?.value) {
    return (
      <CropperWrapper size={size}>
        <Cropper fieldStore={fieldStore} removeFile={handleRemoveFile} />
      </CropperWrapper>
    );
  }

  return (
    <Wrapper size={size}>
      <InputFileStyled
        type='file'
        accept={fieldStore.conf.accept || ''}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onChange={handleChange}
        disabled={disabled}
      />
      <Icon name='upload' size='xlarge' />
    </Wrapper>
  );
});
